export default "__VITE_ASSET__W32Q_HxN__"